<template>
	<div><components :is="imageComponent" /></div>
</template>

<script>
import TableMapperSvg from './assets/TableMapperSvg';
import AiSvg from './assets/AiSvg';
import LoomSvg from './assets/LoomSvg';
import ImageEditorSvg from './assets/ImageEditorSvg';

import {
	TABLE_MAPPER_MINI_APP,
	AI_MINI_APP,
	LOOM_MINI_APP,
	IMAGE_EDITOR_APP,
} from '@/components/BlockEditor/BlockEditorAppSelect/BlockEditorAppSelect.const';

export default {
	name: 'MiniAppImage',
	props: {
		fieldType: { type: String },
	},
	computed: {
		imageComponent() {
			switch (this.fieldType) {
				case TABLE_MAPPER_MINI_APP:
					return TableMapperSvg;
				case AI_MINI_APP:
					return AiSvg;
				case LOOM_MINI_APP:
					return LoomSvg;
				case IMAGE_EDITOR_APP:
					return ImageEditorSvg;
				default:
					console.error(`no image for type.`);
					return null;
			}
		},
	},
};
</script>

<style scoped lang="scss"></style>
